import React from "react"

const EventbriteButton = ({className, children, ebEventId }) => {
    return <a className={className + " eb" + ebEventId} id={ebEventId}>{children}</a>
}
export default EventbriteButton;
